module.exports = __webpack_public_path__ + "img/SmallArrow2.61919a04.svg";